export const unpackFromLocalStorage = localStorageKey => {
  return JSON.parse(localStorage.getItem(localStorageKey));
};

export const addToLocalStorage = (localStorageKey, value) => {
  localStorage.setItem(localStorageKey, JSON.stringify(value));
};
